<script lang="ts">
	import { createEventDispatcher } from "svelte";
	
	import Button from "../../form/Button.svelte";
	import Modal from "../../shared/Modal.svelte";

	export let currentValues: (string|number)[] = [];
	export let prompt: string | undefined;

	let value = '';
	
	let dispatch = createEventDispatcher<{ done: (string|number)[] | undefined}>();

	function add() {
		currentValues.push(value);
		currentValues = currentValues;
		value = '';
	}
	function del(i:number) {
		currentValues.splice(i, 1);
		currentValues = currentValues;
	}
</script>


<Modal on:close={() => dispatch('done')}>
	<span slot="header" class="headline-s bold">{prompt ?? 'Please enter values'}</span>
	<div class="max-w-600 m-auto">
		<input type="text" bind:value={value} on:keyup={(e) => e.code === 'Enter' && add()} />
		<Button type="button" onClick={() => add()}>
			<span class="icon-add-28"></span>
		</Button>
		<div class="pills">
			{#each currentValues as val, i}
				<button on:click={() => del(i)}>
					<span class="icon-close-14"></span>
					{val}
				</button>
			{/each}
		</div>
		<Button type="button" onClick={() => dispatch('done', currentValues)}>Done</Button>
	</div>
</Modal>

